import React from 'react';
import { auth, db } from '../firebase';
import { getAuth, signInWithEmailAndPassword} from 'firebase/auth';
import { func } from 'three/examples/jsm/nodes/code/FunctionNode.js';
import { getDocs, collection } from 'firebase/firestore';
import { useState } from 'react';
import "./css/style.css";

const Admin = () => {
    const [email, setEmail] = useState(''); 
    const [password, setPassword] = useState('');
    const [isauth, setAuth] = useState(false);
    const [projects, setProjects] = useState([]);
    function login() {
        const auth = getAuth();
        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            // Signed in
            const user = userCredential.user;
            setAuth(true);
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
        });
    }

    function Listprojects() { 

        let list = [];
        getDocs(collection(db, "Projects")).then((querySnapshot) => {
            setProjects(querySnapshot.docs.map((doc) => doc.data()));
          });;

          for (let i = 0; i < projects.length; i++) {
            list.push(<li><a href='/admin/project' onClick={() => localStorage.setItem('project', projects[i].name)}>
                {"NAME: " + projects[i].name + " | ID: " + projects[i].id}
                </a></li>);
          }
          return (
            <ul>
                {list}
            </ul>
          )
    }



    if (isauth) {
        



        return (
            <div className="admin">
                <h2 className='centerelements'>Admin</h2>
                <Listprojects/>

            </div>
        );
    }
    else {
        return (
            <div className="admin">
                <div className='login'>
                <h2 className='centerelements'>Login</h2>
                    <ul>
                        <li>
                            <input type="text" placeholder="Email" onChange={(e) => setEmail(e.target.value)}></input>
                        </li>
                        <li>
                            <input type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)}></input>
                        </li>
                    </ul>
                    <button onClick={login}>Login</button>
    
                </div>
            </div>
        );

    }

};



export default Admin;